/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant, Callout, Size, Slider } from "@blueprintjs/core"
import { ChangeEvent, useEffect } from "react"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { __ } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import useSelectedContent from "src/modules/pe-landing-module/hooks/useSelectedContent"

/* Protopia Ecosystem component */
export interface ILandingSettingFormProps {
   
}
const Transform = (props: ILandingSettingFormProps): JSX.Element => {
    return <div className="landing-edit-layer"> 
        <TransformCompact {...props} />
        {/* <SingleTransformPanel /> */}
    </div>
}
export const TransformCompact = (props: ILandingSettingFormProps): JSX.Element => {
    const selectedData  = useSelectedContent()
    const opacity = useSyncState<number>( 0 )
    const rotate = useSyncState<number>( 0 )
    const position = useSyncState<any>( {} )
    const currentLanding = useLandingStore((state:ILandingStore) => state.currentLanding) 

    useEffect(() => {
        const _position = selectedData.data?.position || {}
        opacity.set( typeof _position.opacity === "undefined" ? 1 : _position.opacity )
        rotate.set( _position.rotate || 0 )
        position.set( _position || {} )
    }, [ selectedData.data?.position ])
    
    if( [ SELECT_TYPE.NONE, SELECT_TYPE.BACKGROUND ].includes(selectedData.type) ) {
        return <div />
    } 
    const onChange = (value: any, field: string ) => {
        let reg:RegExp
        switch(field) {
            case "width":
            case "height":
                reg = /[^0-9]/g
                break
            case "opacity":
                reg = /[^0-9,/.]/g
                break
            default:
                reg = /[^0-9,/.,/-]/g
        }
        const val = value.toString().replace(reg,'')  
        position.set({
            ...position.get(),
            [field]: val,
        }) 
    }

    const onOpacity = ( value: number ) => {
        opacity.set( value )
        onChange( value, "opacity" )
    }
    const onRotate = ( value: number ) => {
        rotate.set( value )
        onChange( value, "rotate" )
    }
    const onReset = () => {
        position.set({})
    }
    const onMouseDown = (evt: any) => { 
        evt.preventDefault()
    }
    const onMouseUp = (evt: any) => {
        
    }
    return <div className=" "> 
        <div className="row">
            <div className="col-3 d-flex align-items-center">
                <div className="micro letter-spacing-1 pr-1 w_45">
                    { __( "Left" ) }
                </div>
                <input 
                    type="text" 
                    name="x"
                    className="form-control input dark" 
                    value={position.get().left || 0} 
                    onChange={(evt:ChangeEvent<HTMLInputElement>) => onChange(evt.currentTarget.value, "left")}
                />
            </div>
            <div className="col-3 d-flex align-items-center">
                <div className="micro letter-spacing-1 pr-1 w_45">
                    { __( "Top" ) }
                </div>
                <input 
                    type="text" pattern="[0-9]"
                    name="y"
                    className="form-control input dark" 
                    value={position.y || 0}
                    onChange={(evt:ChangeEvent<HTMLInputElement>) => onChange(evt.currentTarget.value, "top")}
                />
            </div>
            <div className="col-3 d-flex align-items-center">
                <div className="micro letter-spacing-1 pr-1 w_45">
                    { __( "Width" ) }
                </div>
                <input 
                    type="text"                     
                    name="w"
                    className="form-control input dark" 
                    min="0"
                    value={position.get().width || 0} 
                    onChange={(evt:ChangeEvent<HTMLInputElement>) => onChange(evt.currentTarget.value, "width")}
                />
            </div>
            <div className="col-3 d-flex align-items-center">
                <div className="micro letter-spacing-1 pr-1 w_45">
                    { __( "Height" ) }
                </div>
                <input 
                    type="text" 
                    className="form-control input dark" 
                    name="h"
                    min="0"
                    value={position.get().height || 0}
                    onChange={(evt:ChangeEvent<HTMLInputElement>) => onChange(evt.currentTarget.value, "height")}
                />
            </div>
            <div className="col-6 d-flex align-items-center mt-1">
                <div className="small pr-2 w_45">
                    <img src="/assets/img/landing/angle.svg" className="panel-icon" style={{ height: 12, minWidth: 12, width: 12, }} alt=""/>
                </div>
                <div className="px-3 d-flex flex-nowrap">
                    <Slider
                        min={ -180 }
                        max={ 180 } 
                        labelStepSize={ 90 }
                        value={ rotate.get() || 0}
                        onChange={ (val: number) => rotate.set(val) } 
                        onRelease={ onRotate }
                        className="mr-2"
                    /> 
                    <input 
                        type="text" 
                        className="form-control input dark p-0 text-right" 
                        style={{minWidth: 40}}
                        name="rotate"
                        min="0"
                        value={rotate.get() || 0}
                        onChange={(evt:ChangeEvent<HTMLInputElement>) => onChange(evt.currentTarget.value, "rotate")}
                    />
                    <div className="small">
                        º
                    </div>
                </div> 
            </div>
            <div className="col-6 d-flex align-items-center mt-1">
                <div className="small pr-2 w_45">
                    <img src="/assets/img/landing/opacity.svg" className="panel-icon" style={{ height: 12, minWidth: 12, width: 12, }} alt=""/>
                </div>
                <div className="px-3 d-flex">
                    <Slider
                        min={ 0 }
                        max={ 1 }
                        stepSize={ 0.1 }
                        labelStepSize={ .5 }
                        value={ opacity.get() || 1}
                        onChange={ (val: number) => opacity.set(val) } 
                        onRelease={ onOpacity }
                        className="mr-2"
                    /> 
                    <Button 
                        variant={ ButtonVariant.MINIMAL } 
                        size={ Size.SMALL } 
                        icon="cross" 
                        onClick={ onReset }  
                        className="ml-3 hint hint--left"
                        data-hint={ __( "Reset all position" ) }
                    />
                </div> 
            </div>
        </div>
    </div>
}
const TransformStandard = (props: ILandingSettingFormProps): JSX.Element => {
    const selectedData  = useSelectedContent()
    const currentLanding = useLandingStore((state:ILandingStore) => state.currentLanding) 
    if( selectedData.type === SELECT_TYPE.NONE) {
        return <div className="container  mx-2 width-auto">            
            <Callout className="p-4 my-3 letter-spacing-1 row width-auto">
                <div className="small col-12">
                    {__("No Element selected")}
                </div>
                <div className="micro mt-2 col-12">
                    {__("Select some element")}
                </div>
            </Callout>
        </div>
    } 

    const position = selectedData.data?.position || {}

    const onChange = (value: any, _field: string, data: any ) => {        
        console.log( value, _field, data, )
        // const state = useLandingStore.getState().currentLanding
        // const newVal = {
        //     currentLanding : {
        //         ...currentLanding, 
        //         sections: state.sections.map((section: ILandingSection) => {
        //             if(section.id === sectionId) {
        //                 return {
        //                     ...section,
        //                     [field]: value
        //                 }
        //             }
        //             return section
        //         })
        //     },
        //     needUpdate: true
        // }    
        // useLandingStore.setState(newVal)
    } 
    

    return <div className="landing-edit-layer"> 
        <div className="panel-list-2 overflow-y-auto pb-3"> 
            <div className="row"> 
                <FieldInput 
                    type={SCALAR_TYPES.NUMBER}
                    editable 
                    title={"y"}
                    value={ position.top }
                    notClear
                    onChange={onChange}
                />
                <FieldInput 
                    type={SCALAR_TYPES.NUMBER}
                    editable 
                    title={"x"}
                    value={ position.left }
                    notClear
                    onChange={onChange}
                />
                <FieldInput 
                    type={SCALAR_TYPES.NUMBER}
                    editable 
                    title={"w"}
                    value={ position.width }
                    notClear
                    onChange={onChange}
                />
                <FieldInput 
                    type={SCALAR_TYPES.NUMBER}
                    editable 
                    title={"h"}
                    value={ position.height }
                    notClear
                    onChange={onChange}
                />
                <FieldInput 
                    type={SCALAR_TYPES.NUMBER}
                    editable 
                    title={ <div className="micro letter-spacing-2 text-uppercase">rotate</div> }
                    value={ position.rotate }
                    notClear
                    onChange={onChange}
                />
                <FieldInput 
                    type={SCALAR_TYPES.SLIDER}
                    min={0}
                    max={1}
                    stepSize={0.1}
                    labelStepSize={0.25}
                    default={1}
                    editable 
                    disabledLabel
                    title={ <div className="micro letter-spacing-2 text-uppercase">opacity</div> }
                    value={ position.opacity }
                    notClear
                    onChange={onChange}
                />
            </div> 
        </div>
    </div>
}
export default Transform